export const emptyValidator = (data: any) => {
	if (typeof data === "undefined" || data === null || data === "") {
		return 'must not be empty';
	}

	return null;
};
